
export const LoadingButton = ({
  isLoading,
  buttonText,
  customClass,
  disabled,
  onClick,
  iconType = "bi-hand-index-thumb", // Default icon if none provided
}) => {
  return (
    <button
      type="submit"
      className={`${customClass ? customClass : "btn btn-primary col-md-6 d-flex align-items-center justify-content-center gap-2"}`}
      disabled={isLoading || disabled}
      onClick={onClick}
    >
      {isLoading ? (
        <>
          <i className="bi bi-arrow-clockwise spin"></i> {/* Spinning Loader */}
          <span>Loading...</span>
        </>
      ) : (
        <>
          <i className={`bi ${iconType}`}></i> {/* Custom Icon */}
          <span>{buttonText}</span>
        </>
      )}
    </button>
  );
};
